import React from 'react';
import { Link } from 'react-router';

class TrackedAnchor extends React.Component {
	handleClick(e) {

		const dataLayer = global.dataLayer;
		const text = e.currentTarget.textContent;
		const event = this.props.trackEvent !== undefined ?
			this.props.trackEvent : 'Link';
		const eventCategory = this.props.trackEventCategory !== undefined ?
			this.props.trackEventCategory : event;
		const eventAction = this.props.trackEventAction !== undefined ?
			this.props.trackEventAction : text;
		const eventLabel = this.props.trackEventLabel !== undefined ?
			this.props.trackEventLabel : event === 'Link' ?
				global.location.pathname : text;
		dataLayer.push({
			event,
			eventCategory,
			eventAction,
			eventLabel
		});

	}

	render() {
		return (
			<a
				href={ this.props.to }
				style={ this.props.style }
				activeStyle={ this.props.activeStyle }
				className={ this.props.className }
				activeClassName={ this.props.activeClassName }
				onlyActiveOnIndex={ this.props.onlyActiveOnIndex }
				onClick={ e => this.handleClick(e) }
				onMouseOver={ this.props.onMouseOver }
				onMouseOut={ this.props.onMouseOut }
				target={ this.props.target }
				itemProp={ this.props.itemProp }
				rel={ this.props.rel }
			>
				{ this.props.children }
			</a>
		);
	}
}

export default TrackedAnchor;


// WEBPACK FOOTER //
// ./src/pages/common/TrackedAnchor.js